<template>
    <div class="item-form">
        <ul>
            <template v-if="item.planId">
                <li class="form-label-first">{{ $t('Version') }}</li>
                <li id="version_select">
                    <span>{{ item.revision }}</span>
                    <IconButton
                        v-if="editing"
                        :title="$t('Edit Route Plan Version')"
                        icon="revisions-icon"
                        @click="$emit('openRevisions')"
                    />
                </li>
            </template>
            <li :class="item.planId ? 'form-label' : 'form-label-first'">{{ $t('Route Plan Name') }}</li>
            <li>
                <CicTextbox
                    id="plan_name"
                    :enabled="editing"
                    :value="item.name"
                    :maxlength="63"
                    @input="(val) => updateFieldValue('name', val)"
                />
            </li>
        </ul>
        <ServiceSelectorInner
            :editing="editing"
            :access-type="item.voiceOnly ? 0 : 2"
            :route="item.route"
            sip-voicemail
            @change="updateRouteValue"
        />
        <ul>
            <template v-if="item.route.type === 1">
                <li class="form-label">{{ $t('Withhold CLI') }}</li>
                <li>
                    <CicCheckbox
                        id="plan_withhold_cli"
                        :enabled="editing"
                        :value="item.withholdCLI"
                        @input="(val) => updateFieldValue('withholdCLI', val)"
                    />
                </li>
            </template>
            <li class="form-label">{{ $t('Reject calls from withheld number') }}</li>
            <li>
                <CicCheckbox
                    id="plan_reject_clir"
                    :enabled="editing"
                    :value="item.rejectCLIR"
                    @input="(val) => updateFieldValue('rejectCLIR', val)"
                />
            </li>
            <li class="form-label inline-form-item">
                <span>{{ $t('Re-usable Route Plan') }}</span>
                <IconButton icon="help-icon" :title="$t('DESC_ACTIVATE_REUSABLE')" />
            </li>
            <li>
                <CicCheckbox
                    id="plan_reusable"
                    :enabled="editing"
                    :value="item.reusable"
                    @input="(val) => updateFieldValue('reusable', val)"
                />
            </li>
        </ul>
    </div>
</template>

<script>
    import IconButton from '@/components/controls/IconButton';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import ServiceSelectorInner from '@/feature/serviceSelector/ServiceSelectorInner';
    import { getUpdatedRoute } from '@/utils/RouteCollectionUtils';

    export default {
        name: 'EditRoutePlanInner',
        components: {
            CicCheckbox,
            CicTextbox,
            IconButton,
            ServiceSelectorInner,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['change', 'changeList', 'openRevisions'],
        methods: {
            updateRouteValue(field, val) {
                const route = getUpdatedRoute(this.item.route, field, val);
                if (
                    (route.type === 6 && field === 'mappingType') ||
                    ([1, 2].includes(route.type) && field === 'mediaListId')
                ) {
                    this.$emit('changeList', val);
                }

                this.updateFieldValue('route', route);
            },

            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
